<template>
  <div>
    <label
      v-if="!noLabel"
      :class="
        from == 'kanban-unique'
          ? 'fw-500 teams-label-font'
          : from == 'talentpool-filter'
          ? 'acs-input-head'
          : 'teams-label-font'
      "
      >{{ label }} <span v-if="mandatory" class="asterik">*</span></label
    >
    <!-- newmodalinputbox instead of topdiv -->
    <div
      :class="
        from == 'kanban' ? 'newmodalinputbox position-relative' : 'topDiv'
      "
      @mouseover="hovering = true"
      @mouseleave="hovering = false"
    >
      <!-- nothing except w-100 n pointer -->
      <DatePicker
        ref="date"
        tabindex="0"
        class="w-100 pointer"
        :class="{
          'datefield-input': from != 'kanban',
          dateerror: showError,
        }"
        :placeholder="placeholder"
        :format="format"
        :value-type="format"
        :type="datetype"
        v-model="inputData"
        @input="$emit('select-value', inputData)"
        :editable="false"
        :show-second="false"
        :disabled-date="disabledDates"
        :disabled-time="disabledTimeFunction"
        :disabled="disabled"
        :minute-step="minuteInterval"
        :hour-options="futureHours"
        :range="range ? true : false"
        :range-separator="range ? ' to ' : null"
        :default-value="range ? getDefaultRange : []"
      />
      <img
        v-if="hovering && inputData && inputData.length != 0 && !disabled"
        @click.stop="clearInputData"
        :class="
          from == 'kanban' ? 'kanban-calendar-close-icon' : 'close-icon-class'
        "
        class="pointer"
        src="../../assets/New-imgs/CustVend-icons/date-x-close.svg"
        alt=""
      />
      <img
        v-if="icon == 'time'"
        @click.stop="openDatePicker"
        :class="
          from == 'kanban' ? 'kanban-calendar-icons' : 'new-calender-class'
        "
        src="../../assets/img/newkanban/Time.svg"
        alt=""
      />
      <img
        :class="
          from == 'kanban' ? 'kanban-calendar-icons' : 'new-calender-class'
        "
        v-else
        @click.stop="openDatePicker"
        class="pointer"
        src="../../assets/new-calender-icon.svg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "DateField",
  data() {
    return {
      inputData: "",
      hovering: false,
      minuteInterval: 1,
    };
  },
  props: {
    fromCust: Boolean,
    noLabel: Boolean,
    disabled: Boolean,
    type: String,
    label: String,
    mandatory: Boolean,
    placeholder: String,
    id: String,
    showError: Boolean,
    format: String,
    startDate: String,
    endDate: String,
    from: String,
    icon: String,
    disableTime: Boolean,
    startTime: String,
    range: Boolean,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },
  computed: {
    getDefaultRange() {
      const today = new Date();
      const currentMonthStart = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );
      const previousMonthStart = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1
      );
      return [previousMonthStart, currentMonthStart];
    },
    futureHours() {
      const hours = [];
      if (
        this.disableTime &&
        (this.id === "dis-startTime" || this.id === "dis-endTime")
      ) {
        const currentTime = new Date();
        const currentHour = currentTime.getHours();
        for (let hour = currentHour; hour <= 23; hour++) {
          hours.push(hour);
        }
      } else {
        for (let hour = 0; hour <= 23; hour++) {
          hours.push(hour);
        }
      }
      return hours;
    },
    datetype() {
      if (
        this.format === "MM-DD-YYYY" ||
        this.format === "DD-MM-YYYY" ||
        this.format === "YYYY-MM-DD"
      ) {
        return "date";
      } else if (
        this.format === "DD-MM-YYYY HH:mm:ss" ||
        this.format === "MM-DD-YYYY HH:mm:ss"
      ) {
        return "datetime";
      } else if (this.format === "MM-YYYY") {
        return "month";
      } else if (this.format === "YYYY") {
        return "year";
      } else if (this.format === "HH:mm:ss" || this.format === "HH:mm") {
        return "time";
      }
      return "date";
    },
  },
  created() {
    if (this.vmodel) {
      this.inputData = this.vmodel;
    }
    if (this.id === "dis-startTime" || this.id === "dis-endTime") {
      this.minuteInterval = 5;
    }
  },
  watch: {
    vmodel(val) {
      if (val || ["dis-startTime", "dis-endTime"].includes(this.id)) {
        this.inputData = val;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClick);
  },
  methods: {
    handleClick(event) {
      let minutePicker = document.querySelector('[data-type="minute"]');
      let datePickerContainer =
        document.getElementsByClassName("mx-datepicker-main")[0];
      if (minutePicker?.contains(event.target)) {
        datePickerContainer.style.display = "none";
      } else if (datePickerContainer) {
        datePickerContainer.style.display = "";
      }
    },
    disabledTimeFunction(date) {
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const now = new Date();
      if (this.fromCust) {
        return true;
      } else if (this.disableTime && this.id === "dis-startTime") {
        //disable hours befr current time
        if (hours < now.getHours()) return true;

        //disable minutes befr current minute
        if (hours === now.getHours() && minutes <= now.getMinutes())
          return true;

        return false;
      } else if (
        (this.id === "dis-endTime" && this.startTime) ||
        this.id == "end-time"
      ) {
        //disable hours nd minutes before start time
        if (hours < this.startTime.split(":")[0]) return true;
        if (
          hours == this.startTime.split(":")[0] &&
          minutes <= this.startTime.split(":")[1]
        )
          return true;
        return false;
      } else {
        return null;
      }
    },
    openDatePicker() {
      this.$refs.date.$el.children[0].click();
    },
    clearInputData() {
      this.inputData = "";
      this.$emit("select-value", this.inputData);
    },
    convertDateToYYYYMMDD(date) {
      const [day, month, year] = date.split("-");
      return `${year}-${month}-${day}`;
    },

    disabledDates(date) {
      const today = new Date();
      if (this.id == "date-filter-range") {
        const today = new Date();
        return date > today;
      } else if (this.fromCust) {
        return true;
      } else if (this.id == "from-date" || this.id == "fromDate") {
        // Function to disable dates in the future
        return date > today;
      } else if (this.id === "start-date-disable") {
        if (this.endDate) {
          const toDate = this.convertDateToYYYYMMDD(this.endDate);
          const endDate = new Date(toDate);
          endDate.setHours(0, 0, 0, 0);
          return date > endDate || date > today;
        } else {
          return date > today;
        }
      } else if (this.id == "to-date") {
        if (this.startDate) {
          const newDate = new Date(this.startDate);
          return date <= newDate || date >= today;
        } else {
          return date < today;
        }
      } else if (this.id == "to-and-from") {
        // enable current date and future dates
        var dateVal = new Date(date);
        let formatDate = dateVal.toDateString();
        let formatToday = today.toDateString();
        let newDate = new Date(formatToday);
        let newTodayDate = new Date(formatDate);
        return newDate > newTodayDate;
      } else if (this.id == "to-date-special" || this.id == "toDate") {
        if (this.startDate) {
          const startDate = this.convertDateToYYYYMMDD(this.startDate);
          const fromDate = new Date(startDate);
          fromDate.setHours(0, 0, 0, 0);
          const selectedDate = new Date(date);
          selectedDate.setHours(0, 0, 0, 0);
          // Disable dates before fromDate and after today, but not the exact fromDate
          return selectedDate < fromDate || selectedDate > today;
        } else {
          return date > today; // Disable future dates if no startDate is selected
        }
      }
      return null;
    },
  },
};
</script>

<style>
.datefield-input > .mx-input-wrapper > .mx-icon-calendar {
  display: none;
}

.datefield-input > .mx-input-wrapper > .mx-icon-clear {
  display: none;
}

.datefield-input > .mx-input-wrapper > .mx-icon-clear:hover {
  display: none;
}

.topDiv > .dateerror .mx-input {
  border: 1px solid red !important;
  border-radius: 8px !important;
}
.topDiv > .datefield-input .mx-input {
  cursor: pointer;
}
.newmodalinputbox > .dateerror .mx-input {
  border: 1px solid red !important;
  border-radius: 8px !important;
}
.newmodalinputbox > .datefield-input .mx-input {
  cursor: pointer;
}

.new-calender-class {
  position: absolute;
  right: 15px;
  top: 11px;
}

.close-icon-class {
  position: absolute;
  right: 42px;
  top: 12px;
}

.topDiv > .datefield-input .mx-input:disabled {
  background: #f7f7f7 !important;
}

.disabled-pointer {
  cursor: not-allowed;
}

.mx-time-column .mx-time-list::after {
  display: none;
}

.date-picker-hidden {
  display: none;
}

.date-picker-visible {
  display: block;
}
</style>
